import React, { useState, useRef, useEffect } from "react";
import logo from '../Img/ProMed_Logo.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: "",
        number: "",
        email: "",
        message: ""
    });
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const firstFieldRef = useRef(null);

    useEffect(() => {
        if (firstFieldRef.current) firstFieldRef.current.focus();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.number || !/^\d{10}$/.test(formData.number)) newErrors.number = "Valid 10-digit number is required";
        if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Valid email is required";
        if (!formData.message) newErrors.message = "Message is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // const handleSubmit = () => {
    //     if (validate()) {
    //         console.log("Contact Form Submitted:", formData);
    //         alert("Message sent successfully!");
    //         setFormData({ name: "", number: "", email: "", message: "" });
    //     }
    // };

    const handleSubmit = async () => {
        if (validate()) {
            setLoading(true); // start spinner
            try {
                const response = await fetch("https://backend.impactjournal.co.in/contactus", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData)
                });

                const result = await response.json();
                if (response.ok) {
                    toast.success("Message sent successfully!");
                    setFormData({ name: "", number: "", email: "", message: "" });
                } else {
                    toast.error(result.message);
                }
            } catch (err) {
                console.error("Submission failed", err);
                toast.error("Something went wrong.");
            } finally {
                setLoading(false); // stop spinner
            }
        }
    };

    const renderError = (field) =>
        errors[field] && <div className="form-register-error-impact">{errors[field]}</div>;

    return (
        <>
            {/* <ToastContainer position="top-center" autoClose={3000} /> */}
            <div className="register-main-pm contact-us-main-pm">
                <div className="register-section-pm">
                    <div className="contact-panel-wrapper">
                        <h2>Contact us</h2>
                        <p className="contact-description">
                            We're here to help. Please fill out the form below with your inquiry and our team will get back to you shortly.
                        </p>

                        <div className="contact-info-section">
                            <p><strong>Address:</strong> 312A, C Wing, Kailas Business Park, Hiranandani Vikhroli Link Road, Vikhroli (W), Mumbai - 400079
</p>
                            <p><strong>Phone:</strong>+91-022-45035800</p>
                            <p><strong>Email:</strong> info@impactjournal.co.in</p>

                            <div className="contact-socials">
                                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-facebook"></i></a>
                                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-x-twitter"></i></a>
                                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><i class="fa-brands fa-linkedin"></i></a>
                                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>

                    <div className="form-register-wrapper-impact">
                        <h2>Send us a message</h2>
                        <div className="form-register-step-impact">
                            <div className="form-register-input-group-impact">
                                <input
                                    ref={firstFieldRef}
                                    name="name"
                                    placeholder="Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    className="form-register-input-impact"
                                />
                                {renderError("name")}
                            </div>

                            <div className="form-register-input-group-impact">
                                <input
                                    name="number"
                                    placeholder="Phone Number"
                                    value={formData.number}
                                    onChange={handleChange}
                                    className="form-register-input-impact"
                                />
                                {renderError("number")}
                            </div>

                            <div className="form-register-input-group-impact">
                                <input
                                    name="email"
                                    placeholder="Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="form-register-input-impact"
                                />
                                {renderError("email")}
                            </div>

                            <div className="form-register-input-group-impact">
                                <textarea
                                    name="message"
                                    placeholder="Your Message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    className="form-register-input-impact"
                                    rows={5}
                                />
                                {renderError("message")}
                            </div>

                            <div className="form-register-navigation-impact">
                                <button
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    className="form-register-btn-impact form-register-btn-submit-impact"
                                >
                                    {loading ? (
                                        <span className="spinner"></span>
                                    ) : (
                                        "Send Message"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="map-container" style={{ marginTop: "20px" }}>
                <iframe
                    title="ProMed Journal Location"
                    className="contact-us-page-map-pm"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.8452644413584!2d-74.00594108459297!3d40.71277577933162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDQyJzQ2LjAiTiA3NMKwMDAnMjUuMCJX!5e0!3m2!1sen!2sin!4v1611744775827!5m2!1sen!2sin"
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>
            </div>
        </>
    );
};

export default ContactUs;
